/**
 * React hook for accessing PostHog service
 */

import { useMemo } from 'react';
import { PosthogService } from '~/services/posthog';

/**
 * Hook to get PostHog service instance
 */
export const usePosthog = () => {
  const posthog = useMemo(() => PosthogService.getInstance(), []);
  return posthog;
};